module.exports = __webpack_public_path__ + "static/img/cgq.eab6926.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/cgq.png
// module id = l8mK
// module chunks = 1